<div class="font-poppins">
  <nz-card
    *ngIf="!accessGroupFormVisible"
    style="min-height: 400px; margin-bottom: 0px !important"
  >
    <div class="row m-b-30 d">
      <div class="col-lg-7">
        <div class="d-md-flex">
          <div class="m-b-10 m-r-20">
            <nz-input-group [nzPrefix]="prefixTemplate" [nzSuffix]="suffixTemplate">
              <input
                type="text"
                nz-input
                placeholder="Search"
                (keyup)="onKeyUp(searchBox.value)"
                [(ngModel)]="searchTerm"
                #searchBox
              />
            </nz-input-group>
            <ng-template #suffixTemplate>
              <a nz-icon class="opacity-05" (click)="resetSearch()">
                <i nz-icon nzType="close" class="opacity-05"></i>
              </a>
            </ng-template>
            <ng-template #prefixTemplate>
              <i nz-icon nzType="search" class="opacity-05"></i>
            </ng-template>
          </div>
          <div class="m-b-10 m-r-10">
            <button
              nz-button
              nz-popover
              [nzPopoverContent]="popoverContent"
              nzPopoverTrigger="click"
              nzPopoverPlacement="bottom"
              [(nzPopoverVisible)]="filterVisible"
              (nzPopoverVisibleChange)="onPopoverVisibleChange($event)"
              class="btn-outline resource-btn"
              style="text-align: center"
            >
             
            <span *ngIf="this.active && this.isArchived">All Groups</span>

            <span *ngIf="!this.active && !this.isArchived">All Groups</span>
            <span *ngIf="this.active && !this.isArchived">Active</span>
            <span *ngIf="this.isArchived  && !this.active">Archived</span>

              <i
                nz-icon
                nzType="caret-down"
                style="position: relative; top: 1px; left: -3px"
                nzTheme="outline"
              ></i>
            </button>
            <ng-template
              class="filter"
              style="width: 50px; text-align: left; padding: 0px !important"
              #popoverContent
            >
              <div class="" style="width: 180px !important; padding-top: 10px;">
                <div nz-row nzGutter="24">
                  <div
                    nz-col
                    class="gutter-row"
                    nzSpan="24"
                    style="padding-bottom: 15px;"
                  >
                    <span class="filter-heading">Show Groups that are</span>
                  </div>
                </div>
              </div>
              <div style="width: 100%; height: 80px" nz-row>
                <div
                  style="color: #2d2d35; font-family: Poppins !important"
                  nz-col
                  nzSpan="24"
                >
                  <!-- <label nz-checkbox [(ngModel)]="isUsedInLast30Days"
                    >Used in last 30 days</label
                  >
                  <nz-divider
                    style="
                      margin-top: 5px !important;
                      margin-bottom: 10px !important;
                    "
                  ></nz-divider> -->
                  <label nz-checkbox [(ngModel)]="active">Active</label>
                  <nz-divider
                    style="
                      margin-top: 5px !important;
                      margin-bottom: 10px !important;
                    "
                  ></nz-divider>
                  <label nz-checkbox [(ngModel)]="archived">Archived</label>
                  <!-- <nz-divider
                    style="
                      margin-top: 5px !important;
                      margin-bottom: 10px !important;
                    "
                  ></nz-divider> -->
                  <!-- <label nz-checkbox>Also show User Accounts</label> -->
                </div>
              </div>
              <div nz-row>
                <div
                  nz-col
                  nzSpan="24"
                  class="d-flex align-items-center justify-content-between"
                >
                  <span class="cancel-label" (click)="clickFilter()"
                    >Cancel</span
                  >
                  <button
                    class="btn-fill"
                    nz-button
                    nzType="default"
                    nzSize="small"
                    (click)="filterAccessGroupData()"
                  >
                    Apply
                  </button>
                </div>
              </div>
            </ng-template>
          </div>
        </div>
      </div>
      <div class="col-lg-5">
        <div class="d-md-flex justify-content-end">
          <!-- <div class="m-b-10 m-r-10">
            <nz-radio-group class="m-r-10">
              <label
                nz-radio-button
                nzValue="mailView"
                nzTooltipTitle="Mail View"
                nzTooltipPlacement="bottom"
                nz-tooltip
              >
                <i class="font-size-16" nz-icon nzType="mail" theme="fill"></i>
              </label>
              <label
                nz-radio-button
                nzValue="excelView"
                nzTooltipTitle="Excel View"
                nzTooltipPlacement="bottom"
                nz-tooltip
              >
                <i
                  class="font-size-16"
                  nz-icon
                  nzType="file-excel"
                  theme="fill"
                ></i>
              </label>
              <label
                nz-radio-button
                nzValue="printView"
                nzTooltipTitle="Print View"
                nzTooltipPlacement="bottom"
                nz-tooltip
              >
                <i
                  class="font-size-16"
                  nz-icon
                  nzType="printer"
                  theme="fill"
                ></i>
              </label>
            </nz-radio-group>
          </div> -->
          <!-- <div class="m-b-10 m-r-20">
            <nz-radio-group>
              <label
                nz-radio-button
                nzValue="cardView"
                nzTooltipTitle="Card View"
                nzTooltipPlacement="bottom"
                nz-tooltip
              >
                <i
                  class="font-size-16"
                  nz-icon
                  nzType="appstore"
                  theme="fill"
                ></i>
              </label>
            </nz-radio-group>
          </div> -->
       
          <button
            nz-button=""
            nztype=" primary"
            class="font-small-caps btn-custom-light"
            title="Delete"
            *ngIf="anyChecked"
            nz-wave="[object Object]"
            nz-popconfirm   
            nzPopconfirmTitle="Are you sure you want to delete the selected access groups?"
            (nzOnConfirm)="deleteAccessGroup(null, true)"
            nzPopconfirmPlacement="topRight"
            style="margin-right: 10px"
          >
            <i class="font-size-16" nz-icon nzType="delete" theme="fill"></i>
          </button>
          
          <button
          nz-button
            nzType="default"
          class="btn-fill"
          (click)="openAccessGroupForm()"
          >
            <span
            ><i
              class="fa fa-plus button-plus-icon"
              aria-hidden="true"
            ></i></span
          >&nbsp;NEW
          </button>
         
        </div>
      </div>
    </div>

    <div nz-row nzGutter="16">
      <div nz-col class="gutter-row" nzSpan="24">
        <nz-table
          #accessGroupTable
          [nzData]="groupData"
          [nzPageSize]="20"
          [nzLoading]="showLoad"
        >
          <thead (nzSortChange)="sort($event)" nzSingleSort>
            <tr>
              <th
                nzShowCheckbox
                [(nzChecked)]="allChecked"
                (nzCheckedChange)="checkAll($event)"
                [nzDisabled]="this.isArchived"
              ></th>
              <ng-container *ngFor="let column of listOfColumns">
                <th
                  *ngIf="column.name !== ''"
                  [hidden]="column.name === 'Actions' && isArchived"
                  [nzSortOrder]="column.sortOrder"
                  [nzSortFn]="column.sortFn"
                  [nzSortDirections]="column.sortDirections"
                  [nzFilterMultiple]="column.filterMultiple"
                  [nzWidth]="column.colWidth"
                >
                  {{ column.name }}
                 
                </th>
                <th *ngIf="column.name === ''">{{ column.name }}</th>
              </ng-container>
              <!-- <th
                *ngFor="let column of listOfColumns"
                [nzSortOrder]="column.sortOrder"
                [nzSortFn]="column.sortFn"
                [nzSortDirections]="column.sortDirections"
              >
                {{ column.name }}
              </th> -->
            </tr>
          </thead>
          <tbody  [@fadeIn]>
            <ng-template ngFor let-item [ngForOf]="accessGroupTable.data">
              <tr 
                class="data-row cursor-move"
                [ngStyle]="{'opacity': this.isArchived ? '0.7' : '1'}"
                (mouseenter)="rowHoverEnter(item.access_group_id)" 
                (mouseleave)="rowHoverExit(item.access_group_id)"
                
                >
                <td
                  nzShowCheckbox
                  [(nzChecked)]="item.checked"
                  (nzCheckedChange)="refreshStatus()"
                  [nzDisabled]="this.isArchived || item.is_default == 1"
                ></td>

                <td
                (click)="fillAccessGroupForm(item)"
                >
                  <div class="d-flex align-items-center">
                    <nz-avatar [nzSize]="30" nzIcon="user"></nz-avatar>
                    <span class="m-l-10 m-b-0">{{
                      item.access_group_name
                    }}</span>
                    <span *ngIf="item.is_default " class="default_badge">Default</span>

                    <span 
                      *ngIf="!item.is_default && !this.isArchived" 
                      (click)="setGroupAsDefault($event,item.access_group_id)"
                      class="non-default_badge">Set as default</span>
                  </div>
                </td>
                <!-- <td><span *ngIf="!item.access_group_category_name">-</span>
                  {{ item.access_group_category_name }}
                </td> -->
                <td
                  *ngIf="item.is_default == 1"
                (click)="fillAccessGroupForm(item)"
                >{{ totalUserCount }}</td>
                <td  *ngIf="item.is_default !== 1"
                (click)="fillAccessGroupForm(item)">{{ item.user_ids.length }}</td>
                <td
                (click)="fillAccessGroupForm(item)"
                >{{ item.resource_ids.length }}</td>
                <td
                (click)="fillAccessGroupForm(item)">
                  <nz-tag
                    *ngFor="let tag of item.tag; let i = index"
                    [nzMode]="default"
                    [nzColor]="'#ededed'"
                  >
                    {{ tag.tag_name }}
                  </nz-tag>
                </td>

                <td *ngIf="!this.isArchived">
                  <!-- <span class="data-row-action"> -->
                    <span class="">
                    <!-- <a
                      class="m-r-5"
                      nz-button
                      nzType="default"
                      nzShape="circle"
                      nz-tooltip
                      nzTooltipTitle="Edit"
                    >
                      <i
                        nz-icon
                        nzType="edit"
                        theme="outline"
                        (click)="fillAccessGroupForm(item)"
                      ></i>
                    </a> -->
                   
                    <ng-container *ngIf="!item.is_default; else disabledBtn">
                      <button nz-button nzType="default" nzShape="circle" nz-tooltip nzTooltipTitle="Delete" nz-popconfirm
                        nzPopconfirmTitle="Are you sure you want to delete this access group?"
                        (nzOnConfirm)="deleteAccessGroup(item.access_group_id)">
                        <i nz-icon nzType="delete" theme="outline"></i>
                      </button>
                    </ng-container>
                  

                  </span>

                  <ng-template #disabledBtn>
                    <button nz-button nzType="default" nzShape="circle" nz-tooltip nzTooltipTitle="Default group cannot be deleted"
                      disabled>
                      <i nz-icon nzType="delete" theme="outline"></i>
                    </button>
                  </ng-template>
                  <!-- <span class="data-row-action">
                    <i
                      nz-icon
                      nzType="edit"
                      nzTheme="outline"
                      class="edit-position"
                      (click)="fillAccessGroupForm(item)"
                    ></i>
                    <i
                      nz-icon
                      nzType="delete"
                      theme="outline"
                      nz-popconfirm
                      nzPopconfirmTitle="Are you sure you want to delete this access group?"
                      (nzOnConfirm)="deleteAccessGroup(item.access_group_id)"
                    ></i>
                  </span> -->
                </td>
              </tr>
            </ng-template>
          </tbody>
        </nz-table>
      </div>
    </div>
  </nz-card>

  <!-- Access Group Form  -->

  <nz-card *ngIf="accessGroupFormVisible">
    <nz-spin nzTip="Please wait..." [nzSpinning]="isLoading">
        <div nz-row nzGutter="16" class="p-l-15">
          <div nz-col class="gutter-row" nzSpan="24">
            <a title="Cancel" (click)="this.checkFormState()" style="float: right"
              ><i nz-icon nzType="close" theme="outline"></i
            ></a>
          </div>
        </div>
        
        <form [formGroup]="accessGroupForm" nz-form nzLayout="vertical" >
              <div nz-row>
                <div nz-col nzSpan="7">
                  <nz-form-item>
                    <nz-form-label nzRequired>Group Name</nz-form-label>
                    <nz-form-control>
                      <nz-form-control
                        _ngcontent-jfp-c14=""
                        class="ng-tns-c16-67 ant-form-item-control-wrapper ng-star-inserted ant-col-24"
                      >
                        <div class="ant-form-item-control">
                          <span class="ant-form-item-children">
                            <input
                              _ngcontent-jfp-c14=""
                              nz-input=""
                              formControlName="access_group_name"
                              placeholder="Name"
                              nzSize="medium"
                              class="ant-input ng-untouched ng-pristine ng-invalid" required/>
                              <span
                              class="ant-form-item-children-icon"
                            >
                            </span
                          >
                          <span class="text-danger" *ngIf="accessGroupForm.get('access_group_name')?.errors?.['required'] && accessGroupForm.get('access_group_name')?.touched">Group name is required</span>
                        </span>
                        </div>
                      </nz-form-control>
                    </nz-form-control>
                  </nz-form-item>
                </div>
                <div nz-col nzSpan="1">&nbsp;</div>
                <!-- <div nz-col nzSpan="1">
                  <nz-form-item>
                    <nz-form-label>Thumb</nz-form-label>
                    <nz-form-control>
                      <div>
                        <nz-upload
                          class="avatar-uploader"
                          nzAction="https://www.mocky.io/v2/5cc8019d300000980a055e76"
                          nzName="avatar"
                          nzListType="picture-card"
                          [nzShowUploadList]="false"
                          [nzBeforeUpload]="beforeUpload"
                          (nzChange)="handleChange($event)"
                        >
                          <ng-container *ngIf="!avatarUrl">
                            <span
                              class="upload-icon"
                              nz-icon
                              [nzType]="loading ? 'loading' : 'plus'"
                            ></span>
                          </ng-container>
                          <img
                            *ngIf="avatarUrl"
                            [src]="avatarUrl"
                            style="width: 100%"
                          />
                        </nz-upload>
                      </div>
                    </nz-form-control>
                  </nz-form-item>
                </div> -->
                <!-- <div nz-col nzSpan="1">&nbsp;</div> -->
                <div nz-col nzSpan="1">
                  <nz-form-item>
                    <!-- <nz-form-label>Active</nz-form-label>
                    <nz-switch
                      style="padding-top: 0.55rem"
                      formControlName="is_active"
                      (change)="clickSwitch()"
                      
                    ></nz-switch> -->

                    <!-- <nz-switch formControlName="is_active" [(ngModel)]="is_active" [nzControl]="true" (click)="clickSwitch(item)"></nz-switch> -->
                    <!-- <nz-switch
                      [(ngModel)]="active_status"
                      [nzSize]="small"
                      class="mt-2"
                      (ngModelChange)="onToggleChange($event)"
                    ></nz-switch> -->
                  </nz-form-item>
                </div>
                <div nz-col nzSpan="1">&nbsp;</div>

                <div nz-col nzSpan="7">
                  <nz-form-item>
                    <nz-form-label nzFor="Tag">Tags</nz-form-label>
                    <nz-form-control>
                      <nz-select
                        formControlName="tag_id"
                        [nzMaxTagCount]="3"
                        [nzMaxTagPlaceholder]="tagPlaceHolder"
                        nzMode="tags"
                        nzPlaceHolder="Please select"
                        [(ngModel)]="selectedTagValues"
                      >
                        <nz-option
                          *ngFor="let item of tagFilterList"
                          [nzLabel]="item.text"
                          [nzValue]="item"
                        ></nz-option>
                      </nz-select>
                      <ng-template #tagPlaceHolder let-selectedList
                        >and {{ selectedList.length }} more selected</ng-template
                      >
                    </nz-form-control>
                  </nz-form-item>
                </div>
              </div> 

              <div nz-row>
                <div
                  nz-col
                  nzSpan="24"
                  style="font-size: 14px; font-weight: 600"
                  class="mt-10"
                >
                  Add resources, knowledge base and other assets to group
                </div>
              </div>
        </form>
        <div id="access-group" class="m-t-20">
          <nz-radio-group [(ngModel)]="radioValue">
            <label nz-radio-button nzValue="0" style="font-weight: 500"
              >1. Resources</label
            >
            <label nz-radio-button nzValue="1" style="font-weight: 500"
              >2. Knowledge Base</label
            >
            <label nz-radio-button nzValue="2" style="font-weight: 500"
              >3. Courses</label
            >
            <label *ngIf="!isDefaultGroup" nz-radio-button nzValue="3" style="font-weight: 500"
              >4. Users</label
            >
     
          </nz-radio-group>
        </div>

        <!-- Design -->
        <div *ngIf="radioValue == '0'">
          <div class="p-h-10 p-v-30">
              <!-- [initiallyCheckedResourceIds]="checkedR" -->
<!-- [resourceData]="resourcesList" -->
            <data-listing
              
              [currentAccessGroupId]="access_group_id"
              [initiallyCheckedResourceIds]="resource_ids"
              (checkedItemsChanged)="onCheckedItemsChanged($event)"
              (getDataFromChild)="getDataFromChild($event)"
              (resetResourceCache)="resetResources($event)"
              
            ></data-listing>
          </div>
        </div>

        <!-- 1 -->
        <div *ngIf="radioValue == '1'">
          <div class="p-h-10 p-v-30">
            <!--  -->
            <knowledge-base-listing
        
              [initiallyCheckedKnowledgeBaseIds]="checkedK"
              [knowledgeBaseData]="knowledgeBasesList"
              (checkedItemsKnowledgeBase)="onCheckedItemsKnowledgeBase($event)"
            ></knowledge-base-listing>
            <!--  -->
          </div>
        </div>

        <!-- 2 -->
        <div *ngIf="radioValue == '2'">
          <div class="p-h-10 p-v-30">
            <course-listing
        
              [resourceIds]="this.checkedC"
              [courseData]="coursesList"
              (checkedItemsCourse)="onCheckedItemsCourse($event)"
            ></course-listing>
          </div>
        </div>

        <div *ngIf="radioValue == '3'">
          <div class="p-h-10 p-v-30">
            <user-listing
          
              (checkedItemsUser)="onCheckedItemsUser($event)"
              [initiallyCheckedUserIds]="checkedU"
              [userData]="usersList"
            ></user-listing>
          </div>
        </div>

        <!-- Design -->
        <div *ngIf="radioValue == '4'">
          <div class="p-h-10 p-v-30">
            <div class="row">
              <div class="col-lg-10">
                <div class="m-b-10 m-r-20">
                  <nz-input-group [nzPrefix]="prefixTemplate">
                    <input type="text" nz-input placeholder="Search" />
                  </nz-input-group>
                  <ng-template #prefixTemplate>
                    <i nz-icon nzType="search" class="opacity-05"></i>
                  </ng-template>
                </div>
                <div class="col-lg-12">
                  <div class="d-flex justify-content-end">
                    <div class="m-b-10 m-r-20">
                      <button
                        nz-button
                        nz-popover
                        nz-popover
                        nzPopoverTrigger="click"
                        nzPopoverPlacement="bottom"
                        class="btn-outline resource-btn"
                        style="text-align: center"
                      >
                        All Users<i
                          nz-icon
                          nzType="caret-down"
                          style="position: relative; top: 1px; left: -3px"
                          nzTheme="outline"
                        ></i>
                      </button>
                    </div>
                    <div class="m-b-10 m-r-10">
                      <button
                        nz-button
                        nzType="default"
                        nz-popover
                        nzPopoverPlacement="bottomRight"
                        nzPopoverTrigger="click"
                        [nzPopoverContent]="contentTemplate"
                        class="btn-fill"
                      >
                        <span
                          ><i
                            class="fa fa-plus button-plus-icon"
                            aria-hidden="true"
                          ></i></span
                        >&nbsp;New
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-5">
                <div class="m-t-20">
                  <nz-table
                    #usersListTable
                    [nzData]="usersList"
                    [nzPageSize]="50"
                    nzShowSizeChanger
                  >
                    <thead>
                      <tr>
                        <th
                          nzShowCheckbox
                          ngDefaultControl
                          [(ngModel)]="allChecked"
                          (ngModelChange)="updateAllChecked()"
                          [ngModelOptions]="{ standalone: true }"
                          class="m-r-15"
                        ></th>
                        <th nzShowSort>Name</th>
                        <th nzShowSort>Type</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let item of usersListTable.data">
                        <ng-container>
                          <td
                            nzShowCheckbox
                            ngDefaultControl
                            [(nzChecked)]="item.checked"
                            [(ngModel)]="item.checked"
                            [ngModelOptions]="{ standalone: true }"
                            class="m-r-15"
                          ></td>
                          <td>{{ item.first_name }}</td>
                          <td>{{ item.role_name }}</td>
                        </ng-container>
                      </tr>
                    </tbody>
                  </nz-table>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div *ngIf="radioValue == '5'">
          <div class="p-h-10 p-v-30">
            <div nz-row>
              <div class="col-lg-12">
                <div class="d-md-flex">
                  <div class="m-b-10 m-r-20">
                    <nz-input-group [nzPrefix]="prefixTemplate">
                      <input type="text" nz-input placeholder="Search" />
                    </nz-input-group>
                    <ng-template #prefixTemplate>
                      <i nz-icon nzType="search" class="opacity-05"></i>
                    </ng-template>
                  </div>
                  <div class="m-b-10 m-r-20">
                    <button
                      nz-button
                      nz-popover
                      nz-popover
                      nzPopoverTrigger="click"
                      nzPopoverPlacement="bottom"
                      class="btn-outline resource-btn"
                      style="text-align: center"
                    >
                      All Resources<i
                        nz-icon
                        nzType="caret-down"
                        style="position: relative; top: 1px; left: -3px"
                        nzTheme="outline"
                      ></i>
                    </button>
                  </div>
                  <div class="m-b-10 m-r-10">
                    <button
                      nz-button
                      nzType="default"
                      nz-popover
                      nzPopoverPlacement="bottomRight"
                      nzPopoverTrigger="click"
                      [nzPopoverContent]="contentTemplate"
                      class="btn-fill"
                    >
                      <span
                        ><i
                          class="fa fa-plus button-plus-icon"
                          aria-hidden="true"
                        ></i></span
                      >&nbsp;New
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-5">
                <div class="m-t-20">
                  <nz-table
                    #resourcesListTable
                    [nzData]="resourcesList"
                    [nzPageSize]="50"
                    nzShowSizeChanger
                    class="no-border-last"
                  >
                    <thead>
                      <tr>
                        <th
                          nzShowCheckbox
                          ngDefaultControl
                          [(ngModel)]="allChecked"
                          (ngModelChange)="updateAllChecked()"
                          [ngModelOptions]="{ standalone: true }"
                          class="m-r-15"
                        ></th>
                        <th nzShowSort>Name</th>
                        <th nzShowSort>Size</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let item of resourcesListTable.data">
                        <ng-container>
                          <td
                            nzShowCheckbox
                            ngDefaultControl
                            [(nzChecked)]="item.checked"
                            [(ngModel)]="item.checked"
                            [ngModelOptions]="{ standalone: true }"
                            class="m-r-15"
                          ></td>
                          <td>
                            <div
                              class="d-flex align-items-center"
                              style="cursor: pointer"
                              [ngClass]="{ active: selectedFile == item.name }"
                              (click)="displayFiles(item)"
                              (contextmenu)="
                                contextMenu($event, contextDropdownTpl, item.name)
                              "
                              [ngClass]="{ active: selectedFile == item.name }"
                            >
                              <div class="font-size-20">
                                <i
                                  *ngIf="item.type == 'folder'"
                                  [twoToneColor]="colorGold"
                                  nz-icon
                                  nzType="folder-open"
                                  theme="twotone"
                                ></i>
                                <i
                                  *ngIf="item.type == 'pdf'"
                                  [twoToneColor]="colorRed"
                                  nz-icon
                                  nzType="file-pdf"
                                  theme="twotone"
                                ></i>
                                <i
                                  *ngIf="item.type == 'doc'"
                                  [twoToneColor]="colorBlue"
                                  nz-icon
                                  nzType="file-word"
                                  theme="twotone"
                                ></i>
                                <i
                                  *ngIf="item.type == 'xls'"
                                  [twoToneColor]="colorCyan"
                                  nz-icon
                                  nzType="file-excel"
                                  theme="twotone"
                                ></i>
                                <nz-avatar
                                  *ngIf="item.type === 'image'"
                                  [nzSize]="30"
                                  nzIcon="user"
                                  [nzSrc]="item.path"
                                ></nz-avatar>
                              </div>

                              <div *ngIf="item.type === 'folder'">
                                <span class="m-l-10 m-b-0">{{
                                  item.category
                                }}</span>
                              </div>

                              <div *ngIf="item.type === 'pdf'">
                                <a style="color: #53535f; cursor: pointer">
                                  <span class="m-l-10 m-b-0">{{
                                    item.resource_name
                                  }}</span>
                                </a>
                              </div>

                              <div *ngIf="item.type === 'image'">
                                <a style="color: #53535f; cursor: pointer">
                                  <span class="m-l-10 m-b-0">{{
                                    item.resource_name
                                  }}</span>
                                </a>
                              </div>
                            </div>
                          </td>
                          <td>{{ item.size }}</td>
                        </ng-container>
                      </tr>
                    </tbody>
                  </nz-table>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div *ngIf="radioValue == '6'">
          <div class="p-h-10 p-v-30">
            <div nz-row>
              <div>
                <div class="d-md-flex">
                  <div class="m-b-10 m-r-20">
                    <nz-input-group [nzPrefix]="prefixTemplate">
                      <input type="text" nz-input placeholder="Search" />
                    </nz-input-group>
                    <ng-template #prefixTemplate>
                      <i nz-icon nzType="search" class="opacity-05"></i>
                    </ng-template>
                  </div>
                  <div class="m-b-10 m-r-20">
                    <button
                      nz-button
                      nz-popover
                      nz-popover
                      nzPopoverTrigger="click"
                      nzPopoverPlacement="bottom"
                      class="btn-outline resource-btn"
                      style="text-align: center"
                    >
                      All Knowledge Base<i
                        nz-icon
                        nzType="caret-down"
                        style="position: relative; top: 1px; left: -3px"
                        nzTheme="outline"
                      ></i>
                    </button>
                  </div>
                  <div class="m-b-10 m-r-10">
                    <button
                      nz-button
                      nzType="default"
                      nz-popover
                      nzPopoverPlacement="bottomRight"
                      nzPopoverTrigger="click"
                      [nzPopoverContent]="contentTemplate"
                      class="btn-fill"
                    >
                      <span
                        ><i
                          class="fa fa-plus button-plus-icon"
                          aria-hidden="true"
                        ></i></span
                      >&nbsp;New
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-5">
                <div class="m-t-20">
                  <nz-table
                    #kbListTable
                    [nzData]="knowledgeData"
                    [nzPageSize]="50"
                    nzShowSizeChanger
                    class="no-border-last"
                  >
                    <thead>
                      <tr>
                        <th
                          nzShowCheckbox
                          ngDefaultControl
                          [(ngModel)]="allChecked"
                          (ngModelChange)="updateAllChecked()"
                          [ngModelOptions]="{ standalone: true }"
                        ></th>
                        <th nzShowSort>Name</th>
                        <th nzShowSort>Tag</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let item of kbListTable.data">
                        <ng-container>
                          <td
                            nzShowCheckbox
                            ngDefaultControl
                            [(nzChecked)]="item.checked"
                            [(ngModel)]="item.checked"
                            [ngModelOptions]="{ standalone: true }"
                            class="m-r-15"
                          ></td>
                          <td>{{ item.name }}</td>
                          <td>
                            <nz-tag nzMode="default" [nzColor]="'#ededed'"
                              >Res</nz-tag
                            >
                          </td>
                        </ng-container>
                      </tr>
                    </tbody>
                  </nz-table>
                </div>
              </div>
            </div>
          </div>
        </div>
              <!-- Loading overlay
              <div class="overlay" *ngIf="isLoading"></div> -->

        <div nz-row>
          <div nz-col nzSpan="12">
            <button
              *ngIf="!updateMode"
              _ngcontent-jfp-c14=""
              nz-button=""
              nztype="default"
              class="ant-btn ant-btn-default"
              nz-wave="[object Object]"
              (click)="resetAccessGroupForm()"
            >
              <!----><span>Reset</span>
            </button>
            <button
              *ngIf="updateMode"
              _ngcontent-jfp-c14=""
              nz-button=""
              nztype="default"
              class="ant-btn ant-btn-default"
              nz-wave="[object Object]"
              (click)="resetUpdateForm()"
            >
              <!----><span>Reset</span>
            </button>
          </div>
          <!-- padding-top: 10px;
          padding-bottom: 10px; -->
          <div
            nz-col
            nzSpan="12"
            style="display: flex; align-items: center; justify-content: flex-end"
          >
            <!-- (click)="closeAccessGroupForm()" -->

            <!-- <button
              _ngcontent-jfp-c14=""
              nz-button=""
              nztype="default"
              class="ant-btn ant-btn-default m-r-15"
              nz-wave="[object Object]"
              (click)="this.checkFormState()"
            >
              <span>Cancel</span>
              
            </button> -->
            <button
              nz-button=""
              nztype="default"
              class="cancelbtn-outline"
              (click)="this.checkFormState()"
            >
              <span>Cancel</span>
            </button>
            <button
              _ngcontent-jfp-c14=""
              nz-button=""
              nztype="default"
              class="ant-btn ant-btn-primary m-l-10"
              *ngIf="!updateMode"
              (click)="submitAccessGroup()"
              nz-wave="[object Object]"
              [nzLoading]="isLoading"
              [disabled]="
                !this.accessGroupForm.valid ||
                this.checkedUserItems.length === 0 ||
                (this.checkedResourceItems.length === 0 &&
                  this.checkedCourseItems.length === 0 &&
                  this.checkedKnowledgeBaseItems.length === 0)
              "
            >
              <!----><span>Submit</span>
            </button>

            <button
              _ngcontent-jfp-c14=""
              (click)="updateAccessGroup()"
              nz-button=""
              nztype="default"
              class="ant-btn ant-btn-primary m-l-10"
              *ngIf="updateMode"
              [nzLoading]="isLoading"
              nz-wave="[object Object]"
              [disabled]="this.accessGroupForm.invalid"
            >
              <!----><span>Update</span>
            </button>
          </div>
        </div>
    </nz-spin>

  </nz-card>
</div>
